export default __webpack_public_path__ + "static/media/img3.50e83703.png";